module.exports = __webpack_public_path__ + "static/bianca-9c653b1c0b0d09eb4b226668291466ba.jpg";